import { createContext, useContext } from 'react';
import { useManagerHierarchy } from '../hooks/useManagerHierarchy';

const ManagerHierarchyContext = createContext(null);

export function ManagerHierarchyProvider({ children }) {
  const hierarchy = useManagerHierarchy();
  return (
    <ManagerHierarchyContext.Provider value={hierarchy}>
      {children}
    </ManagerHierarchyContext.Provider>
  );
}

export function useManagerHierarchyContext() {
  const value = useContext(ManagerHierarchyContext);
  if (!value) {
    throw new Error('useManagerHierarchyContext must be used within ManagerHierarchyProvider');
  }
  return value;
}

export function useOptionalManagerHierarchy() {
  return useContext(ManagerHierarchyContext);
}
